// extracted by mini-css-extract-plugin
export default {"select":"LabeledSelect_select__XGzBT","selectContainer":"LabeledSelect_selectContainer__eMAc9"};